import React from 'react';

import {StreamBankLink} from "../../StreamBankLink";

export const CreateConservationActionActivityFeedItemDescription = props => {
    let conservationActionTypeString = (props.CustomEventData.contextNode && props.CustomEventData.contextNode.title) ? props.CustomEventData.contextNode.title + " " : "";
    return <p>
        {props.Event.Activity.User?.name ?? 'StreamBank'} added a Conservation Action called <StreamBankLink
        Context={props.Event.ContextNodeDetails.link}>{conservationActionTypeString}</StreamBankLink>.
    </p>;
};


